import React, { useState, useEffect } from "react";
import IconoMovimiento from "../../UI/IconoMovimiento.js";
import IconoTitulo from "../../UI/IconoTitulo.js";
import MensajeCargando from "../../UI/MensajeCargando.js";
import MensajeError from "../../UI/MensajeError.js";
import * as TipoEquipo from "../../constantes/TipoEquipo.js";
import { encontrarIdNumber } from "../../funciones/FuncionesArray.js";
import { NombreEquipoCategoria } from "../../funciones/FuncionesEquipo.js";
import useGetListaURL from "../../../hooks/useGetListaURL.js";
import styles from "./EquiposTorneo.module.css";

const EquiposTorneo = (props) => {
  const torneo = props.torneo;
  const categoria = props.categoria;
  const [equipos, setEquipos] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const idTorneo = torneo ? torneo.id : null;

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (idTorneo) {
      fetchData("torneos/"+idTorneo+"/participantes", setEquipos);
    } else {
      setEquipos([]);
    }
  }, [idTorneo, fetchData]);

  const equipoElegidoHandler = (event) => {
    const equipoEncontrado = encontrarIdNumber(equipos, event.target.id);
    if (equipoEncontrado) {
      props.onEquipoElegido(equipoEncontrado);
    }
  };

  const armarNombreEquipo = (equipo) => {
    let nombreEquipo = NombreEquipoCategoria(equipo.nombre, equipo.categoria, categoria);
    if (!torneo.pais && equipo.pais && equipo.tipoEquipo.codigo !== TipoEquipo.SELECCION) {
      nombreEquipo += " (" + equipo.pais.nombre + ")";
    }
    return nombreEquipo;
  }

  return (
    <React.Fragment>
      <div className={`${styles.titulo}`}>Participantes</div>
      <div className={`${styles.listado}`}>
        {!isCargando && equipos.map((equipo, index) => (
          <button
            className={`${styles.equipo}`}
            key={equipo.id}
            id={equipo.id}
            onClick={equipoElegidoHandler}
          >
            {armarNombreEquipo(equipo)}
            <IconoTitulo objeto={equipo} />
            <IconoMovimiento objeto={equipo} />
          </button>
        ))}
      </div>
      <MensajeCargando isCargando={isCargando} />
      <MensajeError errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default EquiposTorneo;
